export default function setTussCodeMask(value) {
    console.log('ONCHANGE', value)
    return value
      .replace(/\D/g, "")
      .replace(/(\d{1})(\d{1,2})/, "$1.$2")
      
      .replace(/(\d{2})(\d{1,2})/, "$1.$2")
      .replace(/(\d{2})(\d{1,2})/, "$1.$2")
      .replace(/(.\d{3})\d+?$/, "$1")
  }